<app-date></app-date>
<app-weather *ngIf="weather" [city]="city" [forecast]="weather.currently"></app-weather>
<app-hourly *ngIf="weather" [hourlyForecast]="weather.hourly"></app-hourly>
<app-forecast *ngIf="weather" [forecast]="weather.daily.data"></app-forecast>
